import React from 'react';
// import * as _ from 'lodash';
// import {FormGroup, InputGroup} from 'react-bootstrap';
import Select from 'react-select';
// import FontAwesome from 'react-fontawesome';
import {connect} from 'react-redux';
import {setOption} from './FormAction';
import {LoadCategoryOptions} from './FormUtils';
// import SWTCarNewSeriesModal from '../../../view/workdoc/SWTCarNewSeriesModal';

class SelectCarSeries extends React.Component {

  constructor(...args) {
    super(...args);
    // this.initial();
    this.state = {
      modal: false,
      _model_id: '0'
    };
  }

  componentWillReceiveProps(newProps) {
    let model_id = '0'
    let {_model_id} = this.state
    if (typeof newProps.uiSchema.type!=='undefined'&&newProps.uiSchema.type==="vehicle")
      model_id = (newProps.formContext.formData.vehicle!==null?newProps.formContext.formData.vehicle.model_id:'0')
    else
      model_id = (newProps.formContext.formData.car!==null?newProps.formContext.formData.car.model_id:'0')
    
    if (model_id!=='0'&&_model_id!==model_id) {
      this.loadCategoryOptions(model_id)
    }
  }

  // initial() {
  //   try {
  //     LoadCategoryOptions(this.props.formContext.formData.car.model_id)
  //         .then(options => this.props.setOption({
  //           series_options: options,
  //         }));
  //   } catch (ex) {}
  // }

  loadCategoryOptions(model_id) {
    try {
      this.setState({_model_id:model_id})
      LoadCategoryOptions(model_id)
          .then(options => this.props.setOption({
            series_options: options,
          }));
    } catch (ex) {}
  }

  onFormChange = (e) => {
    // {
    //   series_id: e.value,
    //       series: e.label,
    // }
    this.props.onChange(e);

  };

  openModal = () => {
    this.setState({modal: true});
  };

  closeModal = () => {
    this.setState({modal: false});
  };

  render() {
    const {
      store,
      formData,
      // uiSchema,
      // formContext
    } = this.props;
    
    // let model_id = '0'
    // if (typeof uiSchema.type!=='undefined'&&uiSchema.type==='vehicle')
    //   model_id = formContext.formData.vehicle===null?'0':formContext.formData.vehicle.model_id
    // else
    //   model_id = formContext.formData.car===null?'0':formContext.formData.car.model_id
    
    return (
        // <FormGroup>
        //   <InputGroup>
        //     <Select
        //         readOnly={this.props.readonly}
        //         disabled={this.props.disabled}
        //         placeholder={'โปรดระบุ'}
        //         clearable={false}
        //         value={formData}
        //         options={store.options.series_options}
        //         onChange={this.onFormChange}
        //     >
        //     </Select>
        //     <InputGroup.Addon
        //         readOnly={this.props.readonly}
        //         disabled={this.props.disabled}
        //         className="btn"
        //         onClick={this.openModal}
        //     >
        //       <FontAwesome name="plus" />
        //     </InputGroup.Addon>
        //   </InputGroup>

        //   <SWTCarNewSeriesModal
        //       model_id={model_id}
        //       show={this.state.modal}
        //       onHide={this.closeModal}
        //       onAfterSubmit={(response) => {
        //         this.props.onChange(response.id);
        //         this.loadCategoryOptions(response.id);
        //         this.closeModal();
        //       }}
        //   />
        // </FormGroup>
        <Select
                readOnly={this.props.readonly}
                disabled={this.props.disabled}
                placeholder={'โปรดระบุ'}
                clearable={false}
                value={formData}
                options={store.options.series_options}
                onChange={this.onFormChange}
            >
        </Select>    
    );
  }
};

const mapStateToProps = (state) => ({
  store: state,
});

const mapDispatchToProps = ({
  setOption,
});

const SelectCarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectCarSeries);

export default SelectCarContainer;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/SelectCarSeries.js